import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Helmet } from 'react-helmet';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { ArticleBlockThemeProps, componentConfigurationKey } from '../ArticleBlock.theme';
import { baseUnit } from '../../../theming/baseUnitDefinition';

const createSwimsuitWrapperStyle = (backgroundColor: string) => StyleSheet.create({
  style: {
    backgroundColor,
    padding: `calc(100% / (${16 / 9})) ${baseUnit}px  0px ${baseUnit}px`,
    position: 'relative',
    margin: 0,

  },
});

const createSwimsuitStyle = () => StyleSheet.create({
  style: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});

export const SwimsuitPlayer = () => {
  const { placeholderBackgroundColor } = useTheme<ArticleBlockThemeProps>(componentConfigurationKey);
  const SwimsuitWrapperStyle = createSwimsuitWrapperStyle(placeholderBackgroundColor);
  const SwimsuitStyle = createSwimsuitStyle();
  return (
    <ErrorBoundary>
      <Helmet>
        <script defer src="https://players.voltaxservices.io/players/6/code?mm-subId=30" type="text/javascript" />
      </Helmet>
      <div className={css(SwimsuitWrapperStyle.style)}>
        <div className={`${css(SwimsuitStyle.style)} SwimsuitMMPlayer`} id="SwimsuitMMPlayer" />
      </div>
    </ErrorBoundary>
  );
};
